import { z } from 'zod';

/**
 * Schema for the available provider configs API response
 * Validates the response structure from /api/v1/nango/provider-configs/available
 */
export const availableProviderConfigsResponseSchema = z.object({
  available_providers: z.array(z.string()).default([]),
  unavailable_providers: z.array(z.string()).default([]),
});

/**
 * Type inference from the schema
 */
export type AvailableProviderConfigsResponse = z.infer<
  typeof availableProviderConfigsResponseSchema
>;
